// REAL prod work-plan shapes (pulled 2026-08-18, read-only)
// run through the actual backend buildCaseView, then PII-scrubbed:
// names/case numbers are aliases; hours, codes, statuses, dates, and
// linkage patterns (orphans, unlinked plans, blanks) are untouched.
// Regenerate: tools/gallery-data.mjs. DO NOT hand-edit.
// (Exception 08-24: five name strings re-aliased in place to match the
// hardened scrub: initial+surname, CamelCase, and after-@ third-party forms.)
const planGallery = [
  {
    label: "happy-path: full tree, ~20h, components + CM",
    stats: {
      nRefs: 1,
      dualFam: false,
      dualSnap: false,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 2,
      nOther: 1,
      nActs: 2,
      goal: 20,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 1,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 65,
    matchPct: 1.5,
    totalParticipants: 4240,
    plannedCount: 65,
    plannedPct: 32.3,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "1327b3b1-e929-a46c-acac-6a62e4352564",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7100000",
          current_status_date: "2026-07-23",
          case_manager_name: "Jordan Reed",
          work_plan: {
            plan_id: "2e6cbe5f-fb72-e51c-9068-6a6a31321aed",
            name: "Avery Carter",
            begin_date: "2026-07-23",
            end_date: "2026-10-15",
            components: [
              {
                component_id: "437b5a56-acd5-8c5b-bf21-6a6a39c36102",
                name: "Avery Carter",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-10-15",
                activities: [
                  {
                    activity_id: "78cea146-5bc0-e035-df0e-6a6a3ab2b6b8",
                    name: "Avery Carter",
                    activity_code: "JST_OJR",
                    activity_status: "AC",
                    planned_hours_per_week: 10,
                    begin_date: "2026-10-15",
                    end_date: "2026-10-15",
                  },
                ],
              },
              {
                component_id: "4df1d4f1-f282-0746-d07f-6a6a388aca02",
                name: "Avery Carter",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-10-15",
                activities: [],
              },
            ],
            other_activities: [
              {
                activity_id: "9aa92909-1321-530e-77b6-6a6a3b111d4b",
                name: "Avery Carter",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 10,
                begin_date: "2026-07-23",
                end_date: "2026-10-15",
              },
            ],
          },
        },
      ],
      documents: [],
    },
  },
  {
    label: "dual SNAP (ABAWD+JSAP) collapsed, plan present",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 2,
      nOther: 6,
      nActs: 8,
      goal: 23,
      blankGoalActs: 0,
      apptActs: 1,
      nonAC: 4,
      ojr: 0,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 88,
    matchPct: 2.1,
    totalParticipants: 4240,
    plannedCount: 88,
    plannedPct: 43.8,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "6246252f-6c4c-b2f5-aea1-6a622fcb52b6",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7101111",
          current_status_date: "2026-07-22",
          case_manager_name: "Casey Coleman",
          work_plan: {
            plan_id: "d3f09f50-5f05-3bd3-e093-6a7a641f092d",
            name: "Morgan Bennett- WP",
            begin_date: "2026-08-10",
            end_date: "2026-11-10",
            components: [
              {
                component_id: "64182480-0e74-467e-b684-6a7b442afae0",
                name: "SJS- Morgan Bennett",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-08-10",
                scheduled_end_date: "2026-11-10",
                activities: [
                  {
                    activity_id: "257c3d92-959e-f97f-d133-6a7b4beec4fe",
                    name: "SJS- Morgan Bennett",
                    activity_code: "SJS_JS",
                    activity_status: "AC",
                    planned_hours_per_week: 3,
                    begin_date: "2026-08-10",
                    end_date: "2026-11-10",
                  },
                ],
              },
              {
                component_id: "ef3e07de-d42d-902a-a4ee-6a7b45a290ec",
                name: "Work- Morgan Bennett",
                component_code: "EMP",
                component_status: "AC",
                scheduled_start_date: "2026-08-10",
                scheduled_end_date: "2026-11-10",
                activities: [
                  {
                    activity_id: "cc16cee8-48d0-001b-73dd-6a7b4c190f8a",
                    name: "Work- Morgan Bennett",
                    activity_code: "EMP_UEM",
                    activity_status: "AC",
                    planned_hours_per_week: 17,
                    begin_date: "2026-08-10",
                    end_date: "2026-11-10",
                  },
                ],
              },
            ],
            other_activities: [
              {
                activity_id: "4be56919-1028-9ba0-de8c-6a67da169b3b",
                name: "Morgan Bennett- SJS",
                activity_code: "SJS_JS",
                activity_status: "CP",
                planned_hours_per_week: 5,
                begin_date: "2026-07-27",
                end_date: "2026-08-03",
              },
              {
                activity_id: "59ee0f9c-ece1-70db-7ff1-6a67dbb27a04",
                name: "Morgan Bennett- Re-entry Class",
                activity_code: "OTH_OTH",
                activity_status: "AC",
                planned_hours_per_week: 2,
                begin_date: "2026-07-27",
                end_date: "2026-10-19",
              },
              {
                activity_id: "6e2565d8-2c20-b248-752f-6a67dd751515",
                name: "Morgan Bennett- SJS",
                activity_code: "SJS_JS",
                activity_status: "DS",
                planned_hours_per_week: 8,
                begin_date: "2026-08-04",
                end_date: "2026-08-10",
              },
              {
                activity_id: "6e361fa8-d8be-c100-a427-6a67d9a4dcc6",
                name: "Morgan Bennett- Resume Devlopment",
                activity_code: "JST_JRT",
                activity_status: "CP",
                planned_hours_per_week: 3,
                begin_date: "2026-07-27",
                end_date: "2026-08-03",
              },
              {
                activity_id: "b4da351b-9bc3-8de2-055d-6a67db3edcaa",
                name: "Morgan Bennett- Community Service",
                activity_code: "COM_COM",
                activity_status: "DS",
                planned_hours_per_week: 10,
                begin_date: "2026-07-27",
                end_date: "2026-08-10",
              },
              {
                activity_id: "c7fe0fc6-efe6-4601-e2b0-6a7225c73f59",
                name: "CMT- Morgan Bennett",
                activity_code: "OTH_CMT",
                activity_status: "AC",
                planned_hours_per_week: 1,
                begin_date: "2026-07-27",
                end_date: "2026-10-19",
              },
            ],
          },
        },
        {
          referral_id: "b71f371a-8fee-280f-37bd-6a622f087409",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7101111",
          current_status_date: "2026-07-22",
          case_manager_name: "Casey Coleman",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "TANF + SNAP dual: empty plan shell",
    stats: {
      nRefs: 2,
      dualFam: true,
      dualSnap: false,
      tanf: true,
      hasPlan: true,
      synthPlan: false,
      nComps: 1,
      nOther: 0,
      nActs: 0,
      goal: 0,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: true,
      tanfPlanActs: 0,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 3,
    matchPct: 0.1,
    totalParticipants: 4240,
    plannedCount: 3,
    plannedPct: 1.5,
    plannedTotal: 201,
    dataNote: {
      side: "crm",
      text: "1 of 1 CRM activities aren't reachable through any shown plan/component (broken links on the CM side).",
    },
    data: {
      referrals: [
        {
          referral_id: "1ca0039d-08b3-c603-9a1f-6a72b62a9821",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "EWS",
          benefit_program_code: "TANF",
          case_number: "7102222",
          current_status_date: "2026-08-04",
          case_manager_name: "Riley Porter",
          work_plan: {
            plan_id: "9a4317a7-02e6-9996-0bdb-6a79e06e1348",
            name: "Quinn Hayes",
            begin_date: "2026-08-03",
            end_date: "2026-02-10",
            components: [
              {
                component_id: "c21d616b-27b1-5315-2d43-6a79e3a9cb57",
                name: "Quinn Hayes",
                component_code: "OTH",
                component_status: "AC",
                scheduled_start_date: "2026-08-03",
                scheduled_end_date: "2027-02-10",
                activities: [],
              },
            ],
            other_activities: [],
          },
        },
        {
          referral_id: "eebc12ea-e9aa-1ea0-2ef7-6a8002389311",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7102222",
          current_status_date: "2026-08-14",
          case_manager_name: "Riley Porter",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "TANF + SNAP dual: no plan anywhere",
    stats: {
      nRefs: 2,
      dualFam: true,
      dualSnap: false,
      tanf: true,
      hasPlan: false,
      synthPlan: false,
      nComps: 0,
      nOther: 0,
      nActs: 0,
      goal: 0,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: false,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 14,
    matchPct: 0.3,
    totalParticipants: 4240,
    plannedCount: 0,
    plannedPct: 0,
    plannedTotal: 201,
    dataNote: {
      side: "crm",
      text: "No plan or activities exist in the CRM. The CM hasn't built anything yet. Not fixable in the portal.",
    },
    data: {
      referrals: [
        {
          referral_id: "9af24858-e5ee-5712-6895-6a716575ab02",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "EWS",
          benefit_program_code: "TANF",
          case_number: "7103333",
          current_status_date: "2026-08-03",
          case_manager_name: null,
          work_plan: null,
        },
        {
          referral_id: "1f31cf0c-5fb6-0c67-2cbf-6a7165c0dc90",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7103333",
          current_status_date: "2026-08-03",
          case_manager_name: null,
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "TANF-only participant",
    stats: {
      nRefs: 1,
      dualFam: false,
      dualSnap: false,
      tanf: true,
      hasPlan: true,
      synthPlan: false,
      nComps: 3,
      nOther: 3,
      nActs: 4,
      goal: 90,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: true,
      tanfPlanActs: 4,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 125,
    matchPct: 2.9,
    totalParticipants: 4240,
    plannedCount: 27,
    plannedPct: 13.4,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "680a1cd8-ab5c-4cb5-7869-6a622f3a7c53",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "EWS",
          benefit_program_code: "TANF",
          case_number: "7104444",
          current_status_date: "2026-07-22",
          case_manager_name: "Morgan Walsh",
          work_plan: {
            plan_id: "ce3ad10b-f03f-a54d-454e-6a6b72916328",
            name: "Rowan Brooks",
            begin_date: "2026-08-01",
            end_date: "2026-12-02",
            components: [
              {
                component_id: "32177220-081a-6d43-f625-6a6b76eb4558",
                name: "Rowan Brooks",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-08-01",
                scheduled_end_date: "2026-08-15",
                activities: [
                  {
                    activity_id: "1b97b8ef-f246-5357-40a4-6a7f52ef4c37",
                    name: "Rowan Brooks",
                    activity_code: "SJS_JS",
                    activity_status: "AC",
                    planned_hours_per_week: 30,
                    begin_date: "2026-08-09",
                    end_date: "2026-10-07",
                  },
                ],
              },
              {
                component_id: "3621d7d9-e34f-595f-8003-6a6b76c11fc2",
                name: "Rowan Brooks",
                component_code: "COM",
                component_status: "AC",
                scheduled_start_date: "2026-08-16",
                scheduled_end_date: "2026-12-02",
                activities: [],
              },
              {
                component_id: "acc8b78b-971b-2159-d668-6a6b76b348da",
                name: "Rowan Brooks",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-08-16",
                scheduled_end_date: "2026-12-02",
                activities: [],
              },
            ],
            other_activities: [
              {
                activity_id: "3e12ffd0-e676-aad3-4cd6-6a6b75592d93",
                name: "Rowan Brooks",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 8,
                begin_date: "2026-08-16",
                end_date: "2026-12-02",
              },
              {
                activity_id: "ce06ade6-b276-4de9-1029-6a6b73a53643",
                name: "Rowan Brooks",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 30,
                begin_date: "2026-08-01",
                end_date: "2026-08-15",
              },
              {
                activity_id: "ddbb0b15-ada0-5691-876a-6a6b753165f3",
                name: "Rowan Brooks",
                activity_code: "COM_COM",
                activity_status: "AC",
                planned_hours_per_week: 22,
                begin_date: "2026-08-16",
                end_date: "2026-12-02",
              },
            ],
          },
        },
      ],
      documents: [],
    },
  },
  {
    label: "orphan activities only (synthesized bare plan)",
    stats: {
      nRefs: 1,
      dualFam: false,
      dualSnap: false,
      tanf: true,
      hasPlan: true,
      synthPlan: true,
      nComps: 0,
      nOther: 3,
      nActs: 3,
      goal: 60,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: true,
      tanfPlanActs: 3,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 18,
    matchPct: 0.4,
    totalParticipants: 4240,
    plannedCount: 18,
    plannedPct: 9,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "19d40ecb-db17-0e18-7fb4-6a6c1f232b1d",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "EWS",
          benefit_program_code: "TANF",
          case_number: "7105555",
          current_status_date: "2026-07-30",
          case_manager_name: "Quinn Mercer",
          work_plan: {
            plan_id: null,
            name: null,
            begin_date: null,
            end_date: null,
            components: [],
            other_activities: [
              {
                activity_id: "1e59e843-8af6-f33b-cb2a-6a73c597c485",
                name: "Skyler Reed",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 8,
                begin_date: "2026-08-20",
                end_date: "2026-12-06",
              },
              {
                activity_id: "4697e154-777c-52f9-215f-6a73c680aff1",
                name: "Skyler Reed",
                activity_code: "COM_COM",
                activity_status: "AC",
                planned_hours_per_week: 22,
                begin_date: "2026-08-20",
                end_date: "2026-12-06",
              },
              {
                activity_id: "e72414e6-bfef-8229-8871-6a73c4fa72ae",
                name: "Skyler Reed",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 30,
                begin_date: "2026-08-05",
                end_date: "2026-08-19",
              },
            ],
          },
        },
      ],
      documents: [],
    },
  },
  {
    label: "mixed: components + loose other_activities",
    stats: {
      nRefs: 1,
      dualFam: false,
      dualSnap: false,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 1,
      nOther: 4,
      nActs: 4,
      goal: 23,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 1,
      ojr: 1,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 41,
    matchPct: 1,
    totalParticipants: 4240,
    plannedCount: 41,
    plannedPct: 20.4,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "2d818bc4-45e8-7850-ec14-6a6436a0ea5f",
          referral_status: "NEW",
          engagement_status: "inprogress",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7106666",
          current_status_date: "2026-07-24",
          case_manager_name: "Taylor Doyle",
          work_plan: {
            plan_id: "a141d1f3-3cd7-3e71-cccc-6a7c9001ccc1",
            name: "Emerson Coleman WP update 8/11/2026",
            begin_date: "2026-08-11",
            end_date: null,
            components: [
              {
                component_id: "f35123a0-05ad-f629-ef94-6a7cdbf6dcab",
                name: "Job Search Training",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-08-11",
                scheduled_end_date: "2026-08-11",
                activities: [],
              },
            ],
            other_activities: [
              {
                activity_id: "2a4434cd-2a3b-4c5c-4c0f-6a7cdb018be1",
                name: "JST",
                activity_code: "JST_OJR",
                activity_status: "AC",
                planned_hours_per_week: 3,
                begin_date: "2026-08-11",
                end_date: "2026-11-11",
              },
              {
                activity_id: "4eafc63e-cb12-53e7-0c8d-6a6b796b6e75",
                name: "Volunteering",
                activity_code: "VOL_VOL",
                activity_status: "DS",
                planned_hours_per_week: 12,
                begin_date: "2026-07-30",
                end_date: "2026-08-11",
              },
              {
                activity_id: "82ec1e2c-870d-39ee-a093-6a6b78f20663",
                name: "Supervised Job Search",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 8,
                begin_date: "2026-07-30",
                end_date: "2026-08-11",
              },
              {
                activity_id: "d1c7cc54-d235-232d-c2bf-6a7cdb43ca15",
                name: "Employment @ Local Organization",
                activity_code: "EMP_UEM",
                activity_status: "AC",
                planned_hours_per_week: 12,
                begin_date: "2026-08-11",
                end_date: "2026-11-11",
              },
            ],
          },
        },
      ],
      documents: [],
    },
  },
  {
    label: "blank goals + appointment rows (ask-your-CM / suppressed)",
    stats: {
      nRefs: 1,
      dualFam: false,
      dualSnap: false,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 3,
      nOther: 0,
      nActs: 3,
      goal: 20,
      blankGoalActs: 1,
      apptActs: 1,
      nonAC: 0,
      ojr: 1,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 36,
    matchPct: 0.8,
    totalParticipants: 4240,
    plannedCount: 36,
    plannedPct: 17.9,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "13345648-8e5f-f16b-e542-6a7165a82244",
          referral_status: "NEW",
          engagement_status: "inprogress",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7107777",
          current_status_date: "2026-08-03",
          case_manager_name: "Rowan Carter",
          work_plan: {
            plan_id: "64f8d386-8a31-b84d-01f3-6a7e0dcb855a",
            name: "9000007 - Work Plan",
            begin_date: "2026-08-12",
            end_date: "2026-11-04",
            components: [
              {
                component_id: "2e505fd2-7faa-409a-d353-6a7e1441536a",
                name: "9000014 - JST",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-08-12",
                scheduled_end_date: "2026-11-04",
                activities: [
                  {
                    activity_id: "c8e06491-e80b-efc7-e5e4-6a7e16675f22",
                    name: "9000021 - JST",
                    activity_code: "JST_OJR",
                    activity_status: "AC",
                    planned_hours_per_week: 3,
                    begin_date: "2026-08-12",
                    end_date: "2026-11-04",
                  },
                ],
              },
              {
                component_id: "57464ccd-77a6-8732-6213-6a7e15a6f799",
                name: "9000028 - CMT",
                component_code: "OTH",
                component_status: "AC",
                scheduled_start_date: "2026-08-12",
                scheduled_end_date: "2026-11-04",
                activities: [
                  {
                    activity_id: "56400ce7-899c-b416-fccf-6a7e17d651b9",
                    name: "9000035 - CMT",
                    activity_code: "OTH_CMT",
                    activity_status: "AC",
                    planned_hours_per_week: null,
                    begin_date: "2026-08-12",
                    end_date: "2026-11-04",
                  },
                ],
              },
              {
                component_id: "c9fabadc-17f3-9c26-4cb2-6a7e154da32f",
                name: "9000042 -Employment",
                component_code: "EMP",
                component_status: "AC",
                scheduled_start_date: "2026-08-12",
                scheduled_end_date: "2026-11-04",
                activities: [
                  {
                    activity_id: "f132cde0-2bca-b6a2-3708-6a7e16fea972",
                    name: "9000049 - Employment",
                    activity_code: "EMP_UEM",
                    activity_status: "AC",
                    planned_hours_per_week: 17,
                    begin_date: "2026-08-12",
                    end_date: "2026-11-04",
                  },
                ],
              },
            ],
            other_activities: [],
          },
        },
      ],
      documents: [],
    },
  },
  {
    label: "replaced/stopped/finished rows exist (all hidden, sum unaffected)",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 3,
      nOther: 0,
      nActs: 3,
      goal: 0,
      blankGoalActs: 1,
      apptActs: 0,
      nonAC: 3,
      ojr: 0,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 18,
    matchPct: 0.4,
    totalParticipants: 4240,
    plannedCount: 18,
    plannedPct: 9,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "ecfcfd62-9a22-a422-62d8-6a5ef0a523a0",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7108888",
          current_status_date: "2026-07-20",
          case_manager_name: "Skyler Bennett",
          work_plan: {
            plan_id: "4dc1f808-7711-c881-f074-6a611bb786a8",
            name: "Finley Bishop WP 7/24/26",
            begin_date: "2026-07-24",
            end_date: "2026-10-23",
            components: [
              {
                component_id: "a175fb8e-5708-5358-f6f1-6a6795bdeed6",
                name: "Volunteer for Finley Bishop",
                component_code: "VOL",
                component_status: "RE",
                scheduled_start_date: "2026-07-27",
                scheduled_end_date: "2026-10-26",
                activities: [
                  {
                    activity_id: "dfe74545-ce5d-5fa5-534e-6a679bf0a3e8",
                    name: "Application for Volunteer Positions",
                    activity_code: "VOL_VOL",
                    activity_status: "RE",
                    planned_hours_per_week: 12,
                    begin_date: "2026-07-27",
                    end_date: "2026-10-26",
                  },
                ],
              },
              {
                component_id: "a4713003-086f-d072-4771-6a679488f03b",
                name: "JST Finley Bishop",
                component_code: "JST",
                component_status: "RE",
                scheduled_start_date: "2026-07-27",
                scheduled_end_date: "2026-10-26",
                activities: [
                  {
                    activity_id: "38ab1c9a-3a21-3fc4-8275-6a679e48abbd",
                    name: "Job Search Training F. Bishop",
                    activity_code: "SJS_JS",
                    activity_status: "RE",
                    planned_hours_per_week: 4,
                    begin_date: "2026-07-27",
                    end_date: "2026-10-26",
                  },
                ],
              },
              {
                component_id: "c117cfa0-c3c0-fc56-4577-6a6794b496a3",
                name: "SJS Finley Bishop",
                component_code: "SJS",
                component_status: "RE",
                scheduled_start_date: "2026-07-27",
                scheduled_end_date: "2026-10-26",
                activities: [
                  {
                    activity_id: "f01901ef-a4f3-edb4-02e7-6a679fecf826",
                    name: "SJS F. Bishop",
                    activity_code: "SJS_JS",
                    activity_status: "RE",
                    planned_hours_per_week: null,
                    begin_date: "2026-07-27",
                    end_date: "2026-10-26",
                  },
                ],
              },
            ],
            other_activities: [],
          },
        },
        {
          referral_id: "738203a4-9cfe-cadf-246f-6a5ef06740de",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7108888",
          current_status_date: "2026-07-20",
          case_manager_name: "Skyler Bennett",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "platform training videos in the plan (OJR)",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 5,
      nOther: 0,
      nActs: 5,
      goal: 24,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 2,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 45,
    matchPct: 1.1,
    totalParticipants: 4240,
    plannedCount: 45,
    plannedPct: 22.4,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "ac9733dc-c40c-7871-0f9e-6a51c17c32c6",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7109999",
          current_status_date: "2026-07-10",
          case_manager_name: "Emerson Hayes",
          work_plan: {
            plan_id: "bc9e1592-0035-9662-7402-6a62655a7e35",
            name: "Work Plan",
            begin_date: "2026-07-23",
            end_date: "2026-07-23",
            components: [
              {
                component_id: "1ad5a45e-69a4-92e8-35f4-6a6bbc74e3e2",
                name: "Hours tracked for CM",
                component_code: "OTH",
                component_status: "AC",
                scheduled_start_date: "2026-07-16",
                scheduled_end_date: "2026-09-23",
                activities: [
                  {
                    activity_id: "632e43fc-03a0-77f8-207a-6a6bbdfa3a19",
                    name: "JST",
                    activity_code: "JST_OJR",
                    activity_status: "AC",
                    planned_hours_per_week: 2,
                    begin_date: "2026-07-16",
                    end_date: "2026-09-23",
                  },
                ],
              },
              {
                component_id: "2b9e09c4-c5e4-96c8-945f-6a63cfee9b0b",
                name: "Jordan Walsh - EMP",
                component_code: "EMP",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-09-23",
                activities: [
                  {
                    activity_id: "dfa9a497-f81f-1bed-39e5-6a63d0b2e3d9",
                    name: "Jordan Walsh - EMP",
                    activity_code: "EMP_SE",
                    activity_status: "AC",
                    planned_hours_per_week: 11,
                    begin_date: "2026-07-23",
                    end_date: "2026-09-23",
                  },
                ],
              },
              {
                component_id: "7177af67-9558-0d23-67e9-6a6267f7ec07",
                name: "Jordan Walsh - SJS",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-09-23",
                activities: [
                  {
                    activity_id: "6f0307c8-764d-0f89-ff19-6a63cfedf67c",
                    name: "Jordan Walsh - SJS",
                    activity_code: "SJS_JS",
                    activity_status: "AC",
                    planned_hours_per_week: 5,
                    begin_date: "2026-07-23",
                    end_date: "2026-09-23",
                  },
                ],
              },
              {
                component_id: "9fda76c8-4ee7-feef-f895-6a6384758cde",
                name: "Jordan Walsh - JST",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-09-23",
                activities: [
                  {
                    activity_id: "ba140be3-301a-4310-d7d2-6a63cc9a305e",
                    name: "Jordan Walsh - JST",
                    activity_code: "JST_OJR",
                    activity_status: "AC",
                    planned_hours_per_week: 4,
                    begin_date: "2026-07-23",
                    end_date: "2026-09-23",
                  },
                ],
              },
              {
                component_id: "b6bd6994-7542-4563-6d11-6a63ce400356",
                name: "Jordan Walsh - VO",
                component_code: "VOL",
                component_status: "AC",
                scheduled_start_date: "2026-07-23",
                scheduled_end_date: "2026-09-23",
                activities: [
                  {
                    activity_id: "475652e5-dfd6-e0c4-5c8c-6a63cecbfd53",
                    name: "JordanWalsh - VO",
                    activity_code: "VOL_VOL",
                    activity_status: "AC",
                    planned_hours_per_week: 2,
                    begin_date: null,
                    end_date: "2026-09-23",
                  },
                ],
              },
            ],
            other_activities: [],
          },
        },
        {
          referral_id: "2ae7005f-4152-2231-b862-6a51c1c18573",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7109999",
          current_status_date: "2026-07-10",
          case_manager_name: "Emerson Hayes",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "heavy plan: most activities (visual stress)",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 5,
      nOther: 0,
      nActs: 5,
      goal: 21,
      blankGoalActs: 0,
      apptActs: 1,
      nonAC: 1,
      ojr: 0,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 201,
    matchPct: 4.7,
    totalParticipants: 4240,
    plannedCount: 201,
    plannedPct: 100,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "43ab818d-dc3a-ced9-7f85-6a6acdfba6e0",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7111110",
          current_status_date: "2026-07-29",
          case_manager_name: "Reese Sullivan",
          work_plan: {
            plan_id: "acec1de1-5e39-1d8f-a424-6a6cd8230776",
            name: "Work Plan- Casey Mercer",
            begin_date: "2026-07-29",
            end_date: "2026-08-10",
            components: [
              {
                component_id: "56d9addf-8bdb-dce9-8ce7-6a6cdad03e5b",
                name: "JST- Casey Mercer",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-07-29",
                scheduled_end_date: "2026-08-10",
                activities: [
                  {
                    activity_id: "4334194a-f589-c376-72c3-6a6ce0ba8bb0",
                    name: "Resume Development",
                    activity_code: "JST_JRT",
                    activity_status: "AC",
                    planned_hours_per_week: 3,
                    begin_date: "2026-07-29",
                    end_date: "2026-08-10",
                  },
                ],
              },
              {
                component_id: "8f786aec-a816-0c11-3f0a-6a72224233bb",
                name: "OTH- Casey Mercer",
                component_code: "OTH",
                component_status: "",
                scheduled_start_date: "2026-07-29",
                scheduled_end_date: "2026-10-29",
                activities: [
                  {
                    activity_id: "8b7ab8ba-4053-6a1c-9a2d-6a72237982e9",
                    name: "CMT- Casey Mercer",
                    activity_code: "OTH_CMT",
                    activity_status: "AC",
                    planned_hours_per_week: 1,
                    begin_date: "2026-07-29",
                    end_date: "2026-10-29",
                  },
                ],
              },
              {
                component_id: "ae4c1fd6-0600-b788-b84f-6a6cda9881b6",
                name: "SJS- Casey Mercer",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-07-29",
                scheduled_end_date: "2026-08-10",
                activities: [
                  {
                    activity_id: "33972cee-03d4-09b0-68cf-6a6ce06666c5",
                    name: "SJS- Casey Mercer",
                    activity_code: "SJS_JS",
                    activity_status: "AC",
                    planned_hours_per_week: 5,
                    begin_date: "2026-07-29",
                    end_date: "2026-08-10",
                  },
                ],
              },
              {
                component_id: "cdb92e96-a2bb-95cd-159d-6a6cdfce8b9c",
                name: "SJS- Casey Mercer",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-08-11",
                scheduled_end_date: "2026-10-29",
                activities: [
                  {
                    activity_id: "b8821e45-eab4-2cad-351d-6a6ce228042f",
                    name: "SJS- Casey Mercer",
                    activity_code: "SJS_JS",
                    activity_status: "RE",
                    planned_hours_per_week: 8,
                    begin_date: "2026-08-11",
                    end_date: "2026-10-29",
                  },
                ],
              },
              {
                component_id: "eac359cf-561a-25ff-7f72-6a6cda02d988",
                name: "Volunteer- Casey Mercer",
                component_code: "VOL",
                component_status: "AC",
                scheduled_start_date: "2026-07-29",
                scheduled_end_date: "2026-10-29",
                activities: [
                  {
                    activity_id: "988ce0f0-9405-82de-223e-6a6ce188965c",
                    name: "Volunteer- Casey Mercer",
                    activity_code: "VOL_VOL",
                    activity_status: "AC",
                    planned_hours_per_week: 12,
                    begin_date: "2026-07-29",
                    end_date: "2026-10-29",
                  },
                ],
              },
            ],
            other_activities: [],
          },
        },
        {
          referral_id: "7a942ec4-e5e5-7b28-2aac-6a6acdc9b865",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7111110",
          current_status_date: "2026-07-29",
          case_manager_name: "Reese Sullivan",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "tiny/zero goal plan",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 2,
      nOther: 1,
      nActs: 1,
      goal: 3,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 16,
    matchPct: 0.4,
    totalParticipants: 4240,
    plannedCount: 16,
    plannedPct: 8,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "12692192-f0a9-5c28-6f9c-6a51c13ec628",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7112221",
          current_status_date: "2026-07-10",
          case_manager_name: "Finley Brooks",
          work_plan: {
            plan_id: "6de9bc6e-be7b-fab4-bc1a-6a6d0d4d2af7",
            name: "Riley Doyle- Riley Doyle and Work Plan",
            begin_date: "2026-07-31",
            end_date: "2026-08-14",
            components: [
              {
                component_id: "47766783-35af-e700-e711-6a6d16f490d0",
                name: "Riley Doyle- Components- JST",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-07-31",
                scheduled_end_date: "2026-08-14",
                activities: [],
              },
              {
                component_id: "71219dd8-f90f-8b86-284a-6a6d11a7a11c",
                name: "Riley Doyle- Components",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-07-31",
                scheduled_end_date: "2026-10-31",
                activities: [],
              },
            ],
            other_activities: [
              {
                activity_id: "b6367e28-b65a-a144-41fa-6a6d1042a667",
                name: "Riley Doyle- Activities- Volunteering",
                activity_code: "VOL_VOL",
                activity_status: "AC",
                planned_hours_per_week: 3,
                begin_date: null,
                end_date: "2026-08-14",
              },
            ],
          },
        },
        {
          referral_id: "c1681988-c48e-0705-1efc-6a7165b309ed",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7112221",
          current_status_date: "2026-08-03",
          case_manager_name: "Finley Brooks",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "activity with no status at all",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: true,
      synthPlan: false,
      nComps: 3,
      nOther: 3,
      nActs: 4,
      goal: 20,
      blankGoalActs: 1,
      apptActs: 1,
      nonAC: 0,
      ojr: 0,
      cm: true,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 1,
      exceptionStatus: 0,
    },
    matchCount: 1,
    matchPct: 0,
    totalParticipants: 4240,
    plannedCount: 1,
    plannedPct: 0.5,
    plannedTotal: 201,
    dataNote: null,
    data: {
      referrals: [
        {
          referral_id: "efe40f26-ee22-5c19-b99e-6a6d708d7c75",
          referral_status: "NEW",
          engagement_status: "inprogress",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7113332",
          current_status_date: "2026-07-31",
          case_manager_name: "Jordan Reed",
          work_plan: {
            plan_id: "5ad5b12f-3683-f0d4-a282-6a7a420cf349",
            name: "Avery Carter WP 8/10/2026",
            begin_date: "2026-08-10",
            end_date: "2026-11-10",
            components: [
              {
                component_id: "66e82038-327d-7f9a-f363-6a7a49a3e81e",
                name: "OTH",
                component_code: "OTH",
                component_status: "AC",
                scheduled_start_date: "2026-08-10",
                scheduled_end_date: null,
                activities: [],
              },
              {
                component_id: "a92e3fda-f620-9ed4-23c6-6a7a4247eab9",
                name: "Supervised Job Search",
                component_code: "SJS",
                component_status: "AC",
                scheduled_start_date: "2026-08-10",
                scheduled_end_date: "2026-11-10",
                activities: [
                  {
                    activity_id: "cb884508-118c-06b3-5f16-6a7a480ec16c",
                    name: "JST",
                    activity_code: "JST_JRT",
                    activity_status: "AC",
                    planned_hours_per_week: 4,
                    begin_date: "2026-08-10",
                    end_date: "2026-08-10",
                  },
                ],
              },
              {
                component_id: "b19a5d6c-5cd2-3596-27a2-6a7a47100ee7",
                name: "JST",
                component_code: "JST",
                component_status: "AC",
                scheduled_start_date: "2026-08-10",
                scheduled_end_date: "2026-11-10",
                activities: [],
              },
            ],
            other_activities: [
              {
                activity_id: "1a7594d4-39f7-8de9-e236-6a7a48744de0",
                name: "Avery Carter Course @ Local Organization",
                activity_code: "CTE_VOC",
                activity_status: "AC",
                planned_hours_per_week: 12,
                begin_date: "2026-08-10",
                end_date: "2026-11-10",
              },
              {
                activity_id: "22e1411e-b180-e182-8066-6a7a4947b72c",
                name: "CMT",
                activity_code: "OTH_CMT",
                activity_status: "",
                planned_hours_per_week: null,
                begin_date: "2026-08-10",
                end_date: null,
              },
              {
                activity_id: "58f39c40-36e6-9a3e-431f-6a7a4438a1e7",
                name: "Supervised Job Search",
                activity_code: "SJS_JS",
                activity_status: "AC",
                planned_hours_per_week: 4,
                begin_date: "2026-08-10",
                end_date: "2026-11-10",
              },
            ],
          },
        },
        {
          referral_id: "c7321e00-31f6-d486-594b-6a6d702eaa92",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7113332",
          current_status_date: "2026-07-31",
          case_manager_name: "Jordan Reed",
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
  {
    label: "no plan at all (empty state)",
    stats: {
      nRefs: 2,
      dualFam: false,
      dualSnap: true,
      tanf: false,
      hasPlan: false,
      synthPlan: false,
      nComps: 0,
      nOther: 0,
      nActs: 0,
      goal: 0,
      blankGoalActs: 0,
      apptActs: 0,
      nonAC: 0,
      ojr: 0,
      cm: false,
      tanfPlanActs: -1,
      nCase: 1,
      statusless: 0,
      exceptionStatus: 0,
    },
    matchCount: 4039,
    matchPct: 95.3,
    totalParticipants: 4240,
    plannedCount: 0,
    plannedPct: 0,
    plannedTotal: 201,
    dataNote: {
      side: "crm",
      text: "No plan or activities exist in the CRM. The CM hasn't built anything yet. Not fixable in the portal.",
    },
    data: {
      referrals: [
        {
          referral_id: "1003b898-f7f0-1c02-d718-6a7e94acc60d",
          referral_status: "NEW",
          engagement_status: "new",
          referral_type: "ABAWD",
          benefit_program_code: "SNAP",
          case_number: "7114443",
          current_status_date: "2026-08-13",
          case_manager_name: null,
          work_plan: null,
        },
        {
          referral_id: "13adb26c-e7e5-c66e-046c-6a7e9463fef7",
          referral_status: "REO",
          engagement_status: "new",
          referral_type: "JSAP",
          benefit_program_code: "SNAP",
          case_number: "7114443",
          current_status_date: "2026-08-13",
          case_manager_name: null,
          work_plan: null,
        },
      ],
      documents: [],
    },
  },
];

export default planGallery;
